type GetAuthToken = () => string | null | undefined;

let _getAuthToken: GetAuthToken = () => null;

export const configure = (opts: { getAuthToken: GetAuthToken }) => {
    _getAuthToken = opts.getAuthToken;
};

export const getAuthToken = (): string => {
    const token = _getAuthToken();
    if (!token) {
        throw new Error('fiscalpopApi: authToken is not available yet');
    }
    return token;
};

interface RequestOptions {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    jsonBody?: unknown;
    formData?: FormData;
    rawBody?: BodyInit;
    credentials?: RequestCredentials;
    parse?: 'json' | 'text' | 'response';
    signal?: AbortSignal;
}

export async function request<T>(url: string, opts: RequestOptions = {}): Promise<T> {
    const { method = 'GET', jsonBody, formData, rawBody, credentials, parse = 'json', signal } = opts;

    const init: RequestInit = { method };
    if (credentials) {
        init.credentials = credentials;
    }
    if (signal) {
        init.signal = signal;
    }
    if (jsonBody !== undefined) {
        init.body = JSON.stringify(jsonBody);
        init.headers = { 'Content-Type': 'application/json' };
    } else if (formData) {
        init.body = formData;
    } else if (rawBody !== undefined) {
        init.body = rawBody;
    }

    const response = await fetch(url, init);

    if (parse === 'response') {
        return response as unknown as T;
    }

    if (!response.ok) {
        const errText = await response.text();
        throw new Error(errText);
    }

    if (parse === 'text') {
        return (await response.text()) as unknown as T;
    }
    return (await response.json()) as T;
}
